// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  voteContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    marginRight: 8,
    borderRadius: 16,
    border: "1px solid #E6E6E6",
    padding: 8
  }
}), { index: 1 })